export const TCE_LISTING_TYPE = {
  STUDENTS_WITHOUT_TCE: 0,
  DRAFTS: 1,
  WAITING_SIGNATURE: 2,
  INTEGRATIVE: 3,
  ACTIVE: 4,
  EXPIRED: 5,
  RESCISSION_TERMS_IN_PROGRESS: 6,
  RESCISSION_TERMS_CONCLUDED: 7,
} as const;

export type TceListingType =
  (typeof TCE_LISTING_TYPE)[keyof typeof TCE_LISTING_TYPE];
